import React from 'react';
import {initReactI18next} from 'react-i18next';
import {I18nManager} from 'react-native';
import * as ReactNativeLocalize from 'react-native-localize';
import i18next from 'i18next';

import {LoadingView} from '/component/base/LoadingView';
import {getAvailableLanguageCodes, readTranslationFile} from '/util/asset.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {log} from '/util/logger.util';

interface TranslationProviderProps {
  children: React.ReactNode;
}
interface TranslationProviderState {
  i18nInitialized: boolean;
}
class TranslationProvider extends React.PureComponent<
  TranslationProviderProps,
  TranslationProviderState
> {
  constructor(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...args);

    this.state = {
      i18nInitialized: false,
    };

    this.updateLocalizationConfig = this.updateLocalizationConfig.bind(this);
  }

  updateLocalizationConfig() {
    // Get a list of all available translation file's language codes ...
    return (
      getAvailableLanguageCodes()
        // ... and let ReactNativeLocalize decide which one is the best to use.
        .then(ReactNativeLocalize.findBestAvailableLanguage)
        .then(({languageTag, isRTL} = {languageTag: 'en', isRTL: false}) => {
          // Update ReactNative's own RTL setting.
          I18nManager.forceRTL(isRTL);

          // Read the translation file from the resolved language tag.
          return readTranslationFile(languageTag).then(translation => ({
            languageTag,
            translation,
          }));
        })
        .then(({languageTag, translation}) => {
          // Set the locale for date formatting purposes
          getDateUtilDefaultInstance().setLocale(languageTag);

          // Initialize i18next for translations
          return i18next.use(initReactI18next).init({
            resources: {
              [languageTag]: {translation},
            },
            lng: languageTag,
            fallbackLng: 'en',

            // React itself is already XSS-safe so there is no need to
            // further escape interpolation values.
            interpolation: {
              escapeValue: false,
            },

            // Output in the console missing translation for languages other than English.
            saveMissing: true,
            missingKeyHandler: (_language, namespace, key, fallbackValue) => {
              if (languageTag !== 'en') {
                log('--- Missing Translation');
                log('    * namespace:     ', namespace);
                log('    * language:      ', languageTag);
                log('    * key:           ', key);
                log('    * fallbackValue: ', fallbackValue);
              }
            },
          });
        })
    );
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    ReactNativeLocalize.addEventListener(
      'change',
      this.updateLocalizationConfig,
    );

    this.updateLocalizationConfig().then(() => {
      this.setState({i18nInitialized: true});
    });
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentWillUnmount() {
    ReactNativeLocalize.removeEventListener(
      'change',
      this.updateLocalizationConfig,
    );
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {children = null} = this.props;
    const {i18nInitialized} = this.state;

    if (i18nInitialized) {
      return children;
    } else {
      return <LoadingView />;
    }
  }
}

export default TranslationProvider;
